export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; roles?: string[] }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'Home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Dashboard',
      meta: {
        icon: 'my-dashboard',
      },
    },
    {
      name: 'bonus',
      displayName: 'Bonus',
      meta: {
        icon: 'mso-payments',
      },
      children: [
        {
          name: 'bonus-dashboard',
          displayName: 'Dashboard',
          meta: { icon: '' },
        },
        {
          name: 'persons',
          displayName: 'Sales',
          meta: { icon: '' },
        },
        {
          name: 'qa-persons',
          displayName: 'QA',
          meta: { icon: '' },
        },
      ],
    },
    {
      name: 'transactions',
      displayName: 'Transactions',
      meta: {
        icon: 'my-transactions',
      },
    },
    {
      name: 'leads',
      displayName: 'Leads',
      meta: {
        icon: 'my-leads',
      },
    },
    {
      name: 'users',
      displayName: 'Users',
      meta: {
        icon: 'my-users',
      },
    },
    {
      name: 'logs',
      displayName: 'Logs',
      meta: {
        icon: 'my-logs',
        roles: ['Admin'],
      },
    },
    {
      name: 'settings',
      displayName: 'Settings',
      meta: {
        icon: 'mso-settings',
        roles: ['Admin'],
      },
    },
    {
      name: 'activity',
      displayName: 'Activity',
      meta: {
        icon: 'mso-history',
      },
    },
    {
      name: 'capture-queue',
      displayName: 'Capture Queue',
      meta: {
        icon: 'mso-schedule',
      },
    },
    // {
    //   name: 'payments',
    //   displayName: 'Payments',
    //   meta: {
    //     icon: 'credit_card',
    //   },
    //   children: [
    //     {
    //       name: 'payment-methods',
    //       displayName: 'Payment methods',
    //     },
    //     {
    //       name: 'pricing-plans',
    //       displayName: 'Pricing plans',
    //     },
    //     {
    //       name: 'billing',
    //       displayName: 'Billing',
    //     },
    //   ],
    // }
  ] as INavigationRoute[],
}
